import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { openFullScreenModal } from 'actions/FullScreenModal';
import UserMoreMenu from 'components/Header/UserMoreMenu';
import { logout } from 'actions/Auth';
import { currentUserSelectors } from '@lifesize/nucleus';
import actions from 'actions/SettingsModal';
import { openAdminConsole } from 'actions/Application';
import { SETTINGS_MODAL, AV_TAB, PROFILE_TAB } from 'constants/SettingsModal';
import { signaling } from '@lifesize/clients.sdk';

function mapDispatchToProps(dispatch) {
  return {
    handleAdminConsoleClick: () => dispatch(openAdminConsole()),
    handleClickSettings: () => {
      dispatch(actions.handleChangeTab(AV_TAB));
      dispatch(openFullScreenModal(SETTINGS_MODAL));
    },
    handleClickMyProfile: () => {
      dispatch(actions.handleChangeTab(PROFILE_TAB));
      dispatch(openFullScreenModal(SETTINGS_MODAL));
    },
    toggleDoNotDisturb: (value) => {
      signaling.settings.setDoNotDisturb(value);
    },
    logout: () => {
      dispatch(logout());
    }
  };
}

const mapStateToProps = (state) => {
  const myInfo = currentUserSelectors.myInfo(state);
  return {
    showAdminConsole: !!myInfo.isSuperUser
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UserMoreMenu));
